import { RouterModule, Routes } from '@angular/router';
import { CoreRoutes } from '../../../core/routes/core.routes';
import { CoreMainTemplateComponent } from '../../../core/templates/core-main-template/core-main-template.component';
import { HomeRoutes } from '../../../home/routes/home.routes';
import { RoleGuard } from '../../../auth/guards/role.guard';
import { NgModule } from '@angular/core';
import { accountGuard } from '../../../account/guards/account.guard';
import { dictionaryResolver } from '../../../dictionary/resolvers/dictionary.resolver';

const routes: Routes = [
  {
    path: CoreRoutes.main,
    component: CoreMainTemplateComponent,
    canActivate: [accountGuard],
    children: [
      {
        path: HomeRoutes.root,
        canActivate: [RoleGuard],
        loadChildren: () =>
          import('../home/cibc-home.module').then(m => m.CibcHomeModule),
      },
    ],
  },
  {
    path: CoreRoutes.error,
    resolve: { dictionary: dictionaryResolver },
    loadComponent: () =>
      import('../../../core/views/core-error-view/core-error-view.component').then(
        m => m.CoreErrorViewComponent
      ),
  },
  {
    path: CoreRoutes.forbidden,
    resolve: { dictionary: dictionaryResolver },
    loadComponent: () =>
      import('../../../core/views/forbidden-error-view/forbidden-error-view.component').then(
        m => m.ForbiddenErrorViewComponent
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CibcCoreRoutingModule {}
